
export const ROUTE_NAMES = {
  LOGIN: 'Login',
  HOME: 'Home',
  LISTA_IMPRESSORAS: 'lista-impressoras'
};
